<template>
  <div class="d-flex flex-row flex-nowrap align-center py-1" :key="teacher.id">
    <v-icon v-if="displayStatus" :color="teacher.status === 'active' ? 'success' : 'error'" small class="mr-2"
      >mdi-circle</v-icon
    >
    <div v-if="!$vuetify.breakpoint.mobile" class="image-wrapper mr-2">
      <img :src="avatar" alt="" />
    </div>
    <div class="name-text">{{ teacher.name }}</div>
    <div class="item-width ml-2" v-if="displayDob">
      <div class="text--disabled">Ngày sinh</div>
      <div class="item-text">{{ teacher.metadata && teacher.metadata.dob | ddmmyyyy }}</div>
    </div>
    <!-- <div class="item-width ml-2" v-if="displayGender">
      <div class="text--disabled">Giới tính</div>
      <div class="item-text">{{ teacher.gender | gender }}</div>
    </div> -->
    <div class="item-width ml-2" v-if="displayCode">
      <div class="text--disabled">Mã số</div>
      <div class="item-text">{{ teacher.code }}</div>
    </div>
    <div class="item-width mr-2">
      <div class="text--disabled">Lĩnh vực</div>
      <div class="item-text">{{ teacher | _get('subjectGroup.title', 'Chưa có') }}</div>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash'

export default {
  props: {
    teacher: Object,
    displayGender: Boolean,
    displaySubjectGroup: Boolean,
    displayCode: Boolean,
    displayDob: { type: Boolean, default: true },
    displayStatus: Boolean,
  },
  computed: {
    avatar() {
      return get(this.teacher, 'avatar.url', '/default-avatar.svg')
    },
  },
}
</script>

<style lang="scss" scoped>
.image-wrapper {
  width: 45px;
  min-width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 4px;
  }
}
.name-width {
  width: 200px;
}
.name-text {
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.item-width {
  width: 100px;
}
.item-text {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
